import { useHead as originalUseHead } from '@vueuse/head';

export default function useHead(head, { appendTitleSuffix = true } = {}) {
  if (appendTitleSuffix) {
    head.title = `${head.title} | Article`;
  }

  originalUseHead(head);
}
